<script setup lang="ts">
import CarouselNextBase from '@/components/lib/shadcn-vue/carousel/CarouselNextBase.vue';
import { useCarousel } from '@/components/lib/shadcn-vue/carousel/useCarousel';

const { orientation, canScrollNext, scrollNext } = useCarousel();

const onClickScrollNext = (e: MouseEvent) => {
  e.preventDefault();
  // カード全体がリンクの一覧では、伝播させるとカードのクリックとして遷移・計測されてしまう
  e.stopPropagation();
  scrollNext();
};
</script>

<template>
  <CarouselNextBase :can-scroll-next="canScrollNext" :on-click-scroll-next="onClickScrollNext" :orientation="orientation" />
</template>
